import { createMutation } from '@tanstack/svelte-query';
import {
	createSceneLoad,
	deleteSceneLoad,
	updateSceneLoad
} from '$lib/api/scene_load';
import { invalidateAfterSceneLoadUpdate } from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { SceneLoadRequest, SceneLoadResponse } from '$lib/types/scene_load';

export const createSceneLoadMutation = (sceneScope: ScopeFn, unitScope: ScopeFn = getUnitScope()) =>
	createMutation<SceneLoadResponse, Error, SceneLoadRequest>(() => ({
		mutationFn: (request) => createSceneLoad(request),
		onSuccess: () =>
			invalidateAfterSceneLoadUpdate(resolveScope(unitScope), resolveScope(sceneScope))
	}));

export const updateSceneLoadMutation = (sceneScope: ScopeFn, unitScope: ScopeFn = getUnitScope()) =>
	createMutation<
		SceneLoadResponse,
		Error,
		{ id: number; request: Partial<SceneLoadRequest> }
	>(() => ({
		mutationFn: ({ id, request }) => updateSceneLoad(id, request),
		onSuccess: () =>
			invalidateAfterSceneLoadUpdate(resolveScope(unitScope), resolveScope(sceneScope))
	}));

export const deleteSceneLoadMutation = (sceneScope: ScopeFn, unitScope: ScopeFn = getUnitScope()) =>
	createMutation<void, Error, number>(() => ({
		mutationFn: (id) => deleteSceneLoad(id),
		onSuccess: () =>
			invalidateAfterSceneLoadUpdate(resolveScope(unitScope), resolveScope(sceneScope))
	}));
